<script>
    export let id = "";
    export let value = "";
    export let handleChange;
    export let placeholder = "";
    export let isRequired = true;
    export let containerClass = "w-full";
    export let fieldName ="";
    export let min;
    export let hasLabel = true;
    export let isDisabled = false;
    export let errorText = "";
    export let name= "";

</script>

<div class="{containerClass}">
    {#if hasLabel}
        <label for={id} class="font-450 text-lg">{fieldName}</label>
    {/if}

    <textarea
        id={id}
        name={name}
        class="w-full input-home {!!errorText ? 'border-error' : ''}"
        placeholder={placeholder}
        bind:value={value}
        on:change={handleChange}
        on:blur={handleChange}
        required={isRequired}
        disabled={isDisabled}
    />

    <div class="pl-3 text-red-500">
        {errorText}
    </div>
</div>
